// @ts-nocheck

import Cookies from "./cookieFun";

/**
 * 获取cookie
 * @param name the cookie name
 * @returns
 */
function getCookie(name) {
  return (document.cookie.match('(^|; )'.concat(name, '=([^;]*)')) || [])[2];
}

/**
 * Set cookie content by name
 * @param name the cookie name
 * @param value the cookie value
 * @param days the cookie life-time
 * @param domain the cookie domain
 * @param path the cookie path
 */
function setCookie(name, value, days, domain, path) {
  var expires = '';
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = '; expires='.concat(date.toUTCString());
  }
  document.cookie = ''.concat(name, '=').concat(value || '').concat(expires, '; domain=').concat(domain || document.domain, '; path=').concat(path || '/', ';');
}

/**
 * Clean cookie content by name
 * @param name the cookie name
 * @param domain the cookie domain
 * @param path the cookie path
 */
function removeCookie(name, domain, path) {
  setCookie(name, '', -1, domain, path);
}
export function _get(key) {
  var opt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var res = undefined;
  try {
    // 默认使用 localStroage
    res = window.localStorage && window.localStorage.getItem(key) || Cookies.get(key, opt);

    // 转换 cookie 内的值到localstorage并删除cookie
    if (Cookies.get(key, opt) && window.localStorage) {
      // 默认使用localstorage
      window.localStorage.setItem(key, res);
      Cookies.remove(key, opt);
    }
  } catch (e) {}
  return res;
}
export function _set(key, value) {
  var opt = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  try {
    // 不支持 localStorage 且字符串长度过长
    if (value && value.length >= 400) {
      // 指定使用cookie 或者 localStorage 不存在
      if (opt.cookie || !window.localStorage) {
        var _console;
        (_console = console) === null || _console === void 0 ? void 0 : _console.warn('Tracert cookie set too long');
        return;
      }
    }
    // 如果强制使用 cookie
    // if (opt.cookie) {
    //   Cookies.set(key, value, opt);
    //   return;
    // }
    if (window.localStorage) {
      window.localStorage.setItem(key, value);
      return;
    }
  } catch (e) {}
  Cookies.set(key, value, opt);
}
export function _remove(key, opt) {
  try {
    var _window, _window$localStorage;
    (_window = window) === null || _window === void 0 ? void 0 : (_window$localStorage = _window.localStorage) === null || _window$localStorage === void 0 ? void 0 : _window$localStorage.removeItem(key);
  } catch (e) {}
  Cookies.remove(key, opt);
}
export { getCookie, setCookie, removeCookie };